<script lang="ts">
	import LucideIcon from '$lib/utils/components/LucideIcon.svelte';

	import { invoices_state } from '$lib/features/invoices/states/invoices_state';
	import { Loc } from '$lib/tools/locale.svelte';
	import { page } from '$app/state';

	const links = [
		{ icon: 'Store', page: '/', tooltip: 'home,the', drill_ins: ['/shipments', '/pickups'] },
		{ icon: 'Boxes', page: '/products', tooltip: 'products,the' },
		{ icon: 'Coins', page: '/invoices', tooltip: 'invoices,the' },
		{ icon: 'UserCog', page: '/profile', tooltip: 'profile,the' }
	];

	const unpaid_invoices_count = $derived(
		(invoices_state.values ?? []).filter((invoice) => invoice.payment_timestamp == null).length
	);

	function is_active(link: (typeof links)[number]) {
		if (page.route.id === link.page) return true;
		return (link.drill_ins?.includes(page.route.id ?? '') ?? false) || false;
	}
</script>

<footer class="fixed bottom-0 left-0 right-0 z-[100] w-full border-t border-border bg-card/95 backdrop-blur-sm">
	<nav
		class="mx-auto flex h-16 w-full max-w-[672px] items-stretch justify-evenly px-1 sm:gap-2 sm:px-4 lg:max-w-[1100px]"
	>
		{#each links as link}
			<a
				href={link.page}
				aria-current={is_active(link) ? 'page' : undefined}
				class="relative flex min-w-0 flex-1 cursor-pointer flex-col items-center justify-center gap-0.5 rounded-lg px-1 transition-colors duration-150
				{is_active(link)
					? 'bg-primary/10 text-primary'
					: 'text-muted-foreground hover:bg-accent hover:text-card-foreground'}"
				aria-label={Loc(link.tooltip)}
			>
				<span class="relative flex items-center justify-center">
					<LucideIcon name={link.icon} />
					{#if link.page === '/invoices' && unpaid_invoices_count > 0}
						<span
							class="absolute -top-2 -end-2 flex h-4 min-w-4 items-center justify-center rounded-full bg-brand-soft px-1 text-[10px] font-bold leading-none text-brand"
						>
							{unpaid_invoices_count}
						</span>
					{/if}
				</span>
				<span class="text-[10px] font-medium leading-none">{Loc(link.tooltip)}</span>
			</a>
		{/each}
	</nav>
	<div class="flex justify-end pb-[env(safe-area-inset-bottom)]" aria-hidden="true"></div>
</footer>
